import { Columns } from '@/types';
/**
 * Generates a single column that displays all POI types with their icons in one cell.
 * This is an alternative approach that shows all POIs in a single "Points of Interest" column.
 *
 * @returns A single Column that displays all POI icons
 */
export const getPoiIconsColumn = (): Columns => ({
  isSortable: false,
  visibility: true,
  key: 'poiIcons',
  columnName: 'Points of Interests',
  displayConfig: {
    type: 'POI_ICONS',
  },
});
